<template>
    <div class="feedback-head">
        <p class="nav">
            <span class="to-left" @click="goBack"><icon name="to-left"></icon></span>
            <span class="title">{{ title }}</span>
        </p>
    </div>
</template>

<script>
import { getCookie } from '../../util/util'

export default {
    name: 'FeedbackHeader',
    props: {
        title: {
            default: '意见反馈'
        },
        isGoback: {
            default: true
        }
    },
    data() {
        return {
            isLogin: getCookie('loginUser'),
            backPath: ''
        }
    },
    beforeMount() {
        this.$store.commit('setShowHeader', false) // 隐藏公共的头部
    },
    methods: {
        goBack() {
            if (this.isGoback) {
                location.href = '/mobile/cn/sc/index.html'
            } else {
                this.$emit('feedback-back')
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.nav {
    height: 0.8rem;
    line-height: 0.8rem;
    margin-bottom: 0.4rem;
    padding-top: 0.2rem;
    position: relative;
    text-align: center;
    .to-left {
        position: absolute;
        left: 0;
        .icon-to-left {
            width: 40px;
        }
    }
    .title {
        font-size: 40px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/feedback/feedback-header.vue